module.exports = __webpack_public_path__ + "img/erweima.34d60508.png";